module.exports = __webpack_public_path__ + "img/car_00063.04b05dfa.jpg";